import apiService, { HOST } from "./BaseApi";
const ENDPOINT_PATH = "report/alert";
import Utils from '@/scripts/Utils';

const AlertApi = {
    generatePdf: async (data, date_time) => apiService.post(ENDPOINT_PATH, { data, date_time, env: Utils.getEnv() }),

    downloadPdf: async (name) => {  
        name = name.split(" ").join("_");
        window.open(HOST + `download/pdf/${"Alertas "+name}`)},
};

export default AlertApi;
